import React from "react";
import "../assets/css/PolicyPages.css";
import { Helmet } from "react-helmet-async";


const TermsAndConditions = () => (
  <>
  <Helmet>
    <title>Terms & Conditions – Farmer Boaz</title>
    <meta name="description" content="The terms and conditions that apply to Farmer Boaz community share orders." />
  </Helmet>
  <div className="policy-container">
    <h1>Terms & Conditions</h1>
    <p><strong>Effective Date:</strong> [05-19-2025]</p>

    <p>Welcome to Farmer Boaz! By accessing or using our website, services, or participating in any campaigns, you agree to the following Terms and Conditions. Please read these terms carefully.</p>
    
    <h2>1. Definitions</h2>
    <p><b>“We”, “Us”, “Our”</b> refers to Farmer Boaz and its operators.<br/>
       <b>“You”, “User”, “Member”</b> means any individual using this website or participating in community campaigns.
    </p>

    <h2>2. Eligibility & Community Membership</h2>
    <ul>
      <li>You must be at least 18 years old or have parental consent to use this website and participate in our campaigns.</li>
      <li>Our campaigns are designed for members of the community only. Commercial resale is strictly prohibited.</li>
    </ul>

    <h2>3. Nature of Products</h2>
    <ul>
      <li>All products offered, including meat, are <b>uninspected by provincial or federal food safety authorities</b> unless otherwise noted.</li>
      <li>Products are intended solely for personal use and community sharing.</li>
      <li>You acknowledge and accept the inherent risks of consuming uninspected products.</li>
    </ul>

    <h2>4. Ordering & Payment</h2>
    <ul>
      <li>By placing an order, you agree to provide accurate, complete, and current information.</li>
      <li>Orders are confirmed immediately and processed once the campaign ends.</li>
      <li><b>All sales are final.</b> No returns or exchanges, except where your order cannot be fulfilled, in which case a full refund will be issued within 48 hours of notification.</li>
    </ul>

    <h2>5. Delivery</h2>
    <ul>
      <li>Deliveries are made within the specified period after the campaign closes (typically within 7 business days).</li>
      <li>Delivery dates and times are estimates and may be subject to change due to unforeseen circumstances.</li>
      <li>It is your responsibility to provide an accurate delivery address and be available to receive your order.</li>
    </ul>

    <h2>6. Health, Safety & Liability</h2>
    <ul>
      <li>By participating in a community share, you acknowledge that products are not for resale, restaurant, or commercial use.</li>
      <li>You agree to hold Farmer Boaz and its operators harmless from any claims, damages, or health outcomes related to the consumption of uninspected meat or other products.</li>
    </ul>

    <h2>7. Refunds & Cancellations</h2>
    <ul>
    <li>If an order cannot be fulfilled, Farmer Boaz will provide a refund within 48 hours of notification.</li>
    <li>Refunds will be issued for the purchase amount <b>minus any non-refundable Stripe transaction fees</b>.</li>
    <li>All other sales are final and non-refundable.</li>
    </ul>

    <h2>8. User Conduct</h2>
    <ul>
      <li>You agree not to misuse the website, post false information, or use Farmer Boaz for illegal purposes.</li>
      <li>Farmer Boaz reserves the right to refuse service, terminate accounts, or cancel orders at its discretion.</li>
    </ul>

    <h2>9. Intellectual Property</h2>
    <p>All content on the website (including text, images, logos, and code) is the property of Farmer Boaz or its licensors and may not be used without permission.</p>

    <h2>10. Third Party Services & Community</h2>
    <ul>
      <li>Our site may contain links to external sites (e.g., Discord). We are not responsible for their content or policies.</li>
      <li>Communication within our community channels (e.g., Discord) must remain respectful and legal.</li>
    </ul>

    <h2>11. Privacy</h2>
    <p>Please see our <a href="/privacy-policy">Privacy Policy</a> to understand how we collect, use, and protect your information.</p>

    <h2>12. Amendments</h2>
    <p>We may update these Terms and Conditions at any time. We will notify users of material changes, and your continued use of the service constitutes agreement to the updated terms.</p>

    <h2>13. Contact</h2>
    <p>For any questions, contact us at <a href="mailto:info@farmerboaz.com">info@farmerboaz.com</a>.</p>
  </div>
  </>
);

export default TermsAndConditions;
